import { useQuery } from "@apollo/client";
import toast from "react-hot-toast";
import { useNavigate } from "react-router-dom";
import { Spinner } from "src/components/Spinner";
import { GetAsoEbiOrders } from "src/graphql/queries";
import useAppStore from "src/store/utils";
import { GetAseobiOrders, GetAseobiOrdersVariables } from "src/utils/gql_types";
import { OrderPayment } from "../Icons";
import AsoebiOrders from "./AsoebiOrders";

const Orders = () => {
  const { event } = useAppStore((state) => state);
  const navigate = useNavigate();

  const { data: asoebiOrders, loading } = useQuery<
    GetAseobiOrders,
    GetAseobiOrdersVariables
  >(GetAsoEbiOrders, {
    variables: {
      event_id: event.uuid,
    },
    fetchPolicy: "cache-and-network",
    onError(error) {
      if (error?.message !== "unauthenticated") {
        toast.error(<p>{error?.message ?? "An error occurred"}</p>);
      } else {
        navigate("/clear");
      }
    },
  });

  const aseobiOrdersData = asoebiOrders?.getAseobiOrders ?? [];
  const hasData = aseobiOrdersData.length > 0;

  // Skeleton UI for loading state
  const renderSkeleton = () => (
    <div className="flex w-full flex-col pr-4">
      {Array(3)
        .fill(0)
        .map((_, i) => (
          <div
            key={i}
            className="m-2 h-[240px] w-full animate-pulse rounded-lg bg-gray-200 lg:h-[150px]"
          />
        ))}
    </div>
  );

  return (
    <div
      className={`flex flex-col transition-all duration-500 ease-in-out ${
        !loading && hasData
          ? "translate-y-0 opacity-100"
          : "translate-y-4 opacity-80"
      }`}
    >
      {loading && !hasData && renderSkeleton()}

      {loading && hasData && (
        <div
          className="inset-0 z-10 flex translate-y-0 items-center justify-center opacity-100 transition-all duration-500 ease-in-out"
          style={{
            pointerEvents: "none", // So it doesn't block clicks after fade
            animation: "fadeOutUp 0.5s forwards ease-in-out",
            animationDelay: hasData ? "0.3s" : "0s",
          }}
        >
          <Spinner />
        </div>
      )}

      {hasData && <AsoebiOrders orders={aseobiOrdersData} />}

      {!loading && !hasData && (
        <div className="flex h-[600px] flex-col items-center justify-center">
          <OrderPayment />
          <p className="mt-8 max-w-[290px] text-center text-base text-gray-500">
            Orders for your Aso-Ebi that you&apos;ve received payment for will
            appear here
          </p>
        </div>
      )}
    </div>
  );
};
export default Orders;
